import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodCategoryImporter  {
    _originalTypeClassName = "zERP.BO.GoodCategoryImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodCategoryImporter.translate = translateService;
}
this.GoodCategoryImporterKey = null;
this._key = this.GoodCategoryImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _GoodCategoryImporterKey:any;
get GoodCategoryImporterKey(): any {
    return this._GoodCategoryImporterKey;
  }
set GoodCategoryImporterKey(value: any) {
    this._GoodCategoryImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GoodCategoryImporterKey == null || $this.GoodCategoryImporterKey == 0;
            }


}